import React from "react";
import { Plus, Trash2 } from "lucide-react";

const inputCls = "w-full py-2 px-3 rounded-xl bg-[#020617] border border-slate-700 text-sm text-white";

export const EMPTY_PALLET = { count: 1, kind: "europe", length_cm: "", width_cm: "", height_cm: "" };

export const totalPallets = (pallets = []) => pallets.reduce((s, p) => s + (Number(p.count) || 0), 0);

export const cleanPallets = (pallets = []) =>
    pallets.filter((p) => Number(p.count) > 0).map((p) => ({
        count: Number(p.count),
        kind: p.kind,
        length_cm: p.kind === "custom" ? Number(p.length_cm) || null : null,
        width_cm: p.kind === "custom" ? Number(p.width_cm) || null : null,
        height_cm: Number(p.height_cm) || null,
    }));

function PalletRow({ p, i, onChange, onRemove, canRemove }) {
    const set = (k) => (e) => onChange({ ...p, [k]: e.target.value });
    const custom = p.kind === "custom";
    return (
        <div className="flex flex-wrap gap-2 items-end" data-testid={`pallet-row-${i}`}>
            <Mini label="Nombre" className="w-20"><input type="number" min="1" required value={p.count} onChange={set("count")} data-testid={`pallet-count-${i}`} className={inputCls} /></Mini>
            <Mini label="Format" className="w-52">
                <select value={p.kind} onChange={set("kind")} data-testid={`pallet-kind-${i}`} className={inputCls}>
                    <option value="europe">Europe 120 x 80</option>
                    <option value="custom">Dimensions spéciales</option>
                </select>
            </Mini>
            {custom && (
                <>
                    <Mini label="Long. (cm)" className="w-24"><input type="number" required value={p.length_cm} onChange={set("length_cm")} data-testid={`pallet-length-${i}`} className={inputCls} /></Mini>
                    <Mini label="Larg. (cm)" className="w-24"><input type="number" required value={p.width_cm} onChange={set("width_cm")} data-testid={`pallet-width-${i}`} className={inputCls} /></Mini>
                </>
            )}
            <Mini label="Haut. (cm)" className="w-24"><input type="number" value={p.height_cm || ""} onChange={set("height_cm")} data-testid={`pallet-height-${i}`} className={inputCls} /></Mini>
            <button type="button" onClick={onRemove} disabled={!canRemove} data-testid={`pallet-remove-${i}`} className="pb-2.5 px-1 text-slate-500 hover:text-red-400 disabled:opacity-30" aria-label="Supprimer"><Trash2 size={15} /></button>
        </div>
    );
}

export default function PalletEditor({ pallets, onChange }) {
    const list = pallets?.length ? pallets : [EMPTY_PALLET];
    const empty = !pallets?.length;
    const update = (i, p) => onChange(list.map((x, j) => (j === i ? p : x)));
    return (
        <div className="space-y-3" data-testid="pallet-editor">
            {list.map((p, i) => (
                <PalletRow key={i} p={p} i={i} onChange={(np) => update(i, np)} onRemove={() => onChange(list.filter((_, j) => j !== i))} canRemove={list.length > 1} />
            ))}
            <div className="flex items-center justify-between">
                <button type="button" onClick={() => onChange([...list, { ...EMPTY_PALLET }])} data-testid="pallet-add" className="text-xs text-orange-300 hover:text-orange-200 inline-flex items-center gap-1"><Plus size={13} /> Ajouter une autre taille</button>
                <span className="text-sm text-slate-300" data-testid="pallet-total">Total : <b>{empty ? 0 : totalPallets(list)}</b> palette(s)</span>
            </div>
        </div>
    );
}

function Mini({ label, className, children }) {
    return (
        <div className={className}>
            <label className="text-[11px] text-slate-400 mb-1 block">{label}</label>
            {children}
        </div>
    );
}
